import clsx from 'clsx'

/**
 * Skeleton placeholder that mirrors the horizontal layout of `ResultUpsellCard`
 * (square image on the left, title / price / ATC stacked on the right) so the
 * loading state matches the real card height and avoids blank space on unload.
 */
export const SkeletonUpsellCard = ({ className }) => {
  return (
    <div className={clsx('flex items-stretch bg-brand-tertiary w-full', className)}>
      <div className="shrink-0 w-[100px] md:w-[120px] aspect-1/1 bg-page-secondary animate-pulse"></div>

      <div className="grow flex flex-col justify-between gap-y-0.75 min-w-0 h-auto px-0.75 py-0.5">
        <div className="flex flex-col gap-y-0.375 min-w-0">
          <div className="w-3/4 h-1.125 bg-page-secondary animate-pulse"></div>
          <div className="w-[60px] h-1.125 bg-page-secondary animate-pulse"></div>
        </div>

        <div className="w-full h-2 bg-page-secondary animate-pulse"></div>
      </div>
    </div>
  )
}
